<script lang="ts" setup>
  withDefaults(defineProps<{ width?: string }>(), {
    width: '24px'
  })
</script>

<template>
  <div class="toolbar-spacer" />
</template>

<style lang="scss" scoped>
  .toolbar-spacer {
    width: v-bind('width');
  }
</style>
